import React from "react";
import { View } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";
import { useRouter } from "expo-router";
import { useThemeColors } from "@/providers/ThemeProvider";
import {
  OnboardingCarousel,
  ADMIN_ONBOARDING_SLIDES,
  ADMIN_ONBOARDING_BUTTON_TEXT,
  useOnboarding,
} from "@/modules/onboarding";

/**
 * Admin Onboarding Screen
 * 
 * Shown when a user is assigned the familie_admin role and clicks
 * the notification action button. Explains admin features with a
 * carousel of slides featuring robot explainer animations.
 */
export default function AdminOnboardingScreen() {
  const router = useRouter();
  const colors = useThemeColors();
  const { completeOnboarding } = useOnboarding("admin");

  /**
   * Handle onboarding completion
   * Marks admin onboarding as complete and navigates to admin dashboard
   */
  const handleComplete = async () => {
    try {
      await completeOnboarding();
    } catch (error) {
      console.error("Error completing admin onboarding:", error);
    }
    // Navigate to admin dashboard
    router.replace("/(tabs)/admin");
  };

  /**
   * Handle back/close button
   */
  const handleBack = () => {
    if (router.canGoBack()) {
      router.back();
    } else {
      router.replace("/(tabs)/admin");
    }
  };

  return (
    <SafeAreaView className="flex-1" style={{ backgroundColor: colors.background }}>
      <OnboardingCarousel
        slides={ADMIN_ONBOARDING_SLIDES}
        finishButtonText={ADMIN_ONBOARDING_BUTTON_TEXT}
        onComplete={handleComplete}
        showBackButton
        onBack={handleBack}
      />
    </SafeAreaView>
  );
}

